import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Title from "./Title";
import Button from "./Button";
import DashboardBox from "./DashboardBox";
import ClearIcon from "@mui/icons-material/Clear";

import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DescriptionIcon from "@mui/icons-material/Description";
import Notification from "../notification/Notification";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useDispatch, useSelector } from "react-redux";
import dataService from "../services/data-service";
import SkletonLoader from "./SkletonLoader";
import SkelotonLoaderLogbox from "./SkelotonLoaderLogbox";
import { toast } from "react-toastify";
import AccountTest from "../profile/account/AccountTest";
import { toByteArray } from "base64-js";

import { getClickedUserData } from "../store/reducerSlices/adminClickedSlice";
import {
  updateClickedUser,
  updateUserData,
} from "../store/reducerSlices/userSlice";
import { Info } from "@mui/icons-material";

const Dashboard = () => {
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [showValidationDialog, setShowValidationDialog] = useState(false);

  const [downloadFields, setDownloadFields] = useState([]);
  const [activeField, setActiveField] = useState("");

  const [errorResponse, setErrorResponse] = useState("");

  // const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();
  // window.location.reload()
  // const idClickedByAdmin = location.state?.userId
  // console.log('idClickedByAdmin', idClickedByAdmin)

  // const fetchClickedUserData = async (id) => {

  //   if (id) {
  //     const response = await dataService.getData(`/UserInformation/getbyid/user?userId=${id}`);
  //     // const clickedIDdata = response.data;

  //     console.log('clickedIDdata', response);
  //     dispatch(getClickedUserData(response))
  //     return response;
  //   } else {
  //     console.log('ID is null');
  //     return null;
  //   }

  // };

  // useEffect(() => {
  //   if (idClickedByAdmin) {
  //     console.log('token coming')
  //     fetchClickedUserData(idClickedByAdmin);
  //     console.log('admin just clicked some id')
  //   }
  // }, [idClickedByAdmin]);

  var user = useSelector((state) => state.user.user);
  var admin = useSelector((state) => state.admin.admin);
  var clickedUser = useSelector((state) => state.adminClickedUser.clickedUser);
  var userClickedByAdmin = useSelector(
    (state) => state.adminClickedUser.clickedUser
  );
  var loggedInData = null;

  if (user) {
    loggedInData = user;
  } else if (admin) {
    loggedInData = admin;
  } else {
    console.log("No user logged in or admin has not clicked any user");
    // Handle the case where no one is logged in
  }

  var completeStatus = false;
  if (loggedInData && loggedInData.completeStatus) {
    completeStatus = loggedInData.completeStatus;
  } else if (userClickedByAdmin) {
    completeStatus = userClickedByAdmin.completeStatus;
  }

  const userId = loggedInData?.userId;
  const role = loggedInData?.role;

  // this below admin data will only be used for the validation case of if admin with role PartnerCenter and userclicked by admin also then we dont allow them to edit any user
  const adminData = admin;
  const adminRole = adminData?.role;

  const { isSidebarCollapsed, openMobileSideBar } = useSelector(
    (state) => state.hamburger
  );

  const handleClose = () => {
    setShowValidationDialog(false);
  };

  const handleDownloadLogbook = async () => {
    const fetchData = async () => {
      setIsLoadingDownload(true);
      // !completeStatus &&
      //   toast.info("Please wait 1 or 2 minutes. This will take time");

      try {
        if (completeStatus) await handleSubmitLogbook();
        // if (!userId || !clickedUser.userId) {
        //   window.location.replace("/");
        // }
        if (!showValidationDialog) {
          const response = await dataService.getData(
            `/DownloadLogbook?userId=${userId || clickedUser.userId}`
          );

          // if(response.)
          setIsLoadingDownload(false);

          let base64String = response;
          // Check if the string is URL-safe and replace characters if needed
          base64String = base64String.replace(/-/g, "+").replace(/_/g, "/");

          // Add padding if necessary
          const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
          base64String += padding;
          // console.log(first);
          // Decode base64 string to binary data using base64-js
          const byteArray = toByteArray(base64String);

          // Create a Blob from the binary data
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Check if showSaveFilePicker is available
          if ("showSaveFilePicker" in window) {
            // Use showSaveFilePicker if available
            const fileHandle = await window.showSaveFilePicker({
              suggestedName: "Logbook.pdf",
              types: [
                {
                  description: "PDF Files",
                  accept: { "application/pdf": [".pdf"] },
                },
              ],
            });

            // Create a writable stream
            const writableStream = await fileHandle.createWritable();
            await writableStream.write(blob);
            await writableStream.close();
          } else {
            // Fallback for browsers that do not support showSaveFilePicker
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Logbook.pdf"; // Set the file name

            // Append to the body
            document.body.appendChild(link);
            link.click(); // Trigger the download

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          }
        }
      } catch (error) {
        // setErrorResponse(error.response.data[0].Module)
        // setErrorResponse(error.response.data)
        // setShowValidationDialog(true)
        // if (completeStatus) {
        //   setErrorResponse(error.response.data);
        //   setShowValidationDialog(true);
        // }
        error?.response?.data && setErrorResponse(error.response.data);
      } finally {
        setIsLoadingDownload(false);
      }
    };
    fetchData();
  };

  const handleSubmitLogbook = async () => {
    const fetchDataSubmit = async () => {
      setIsSubmit(true);
      // if (!isLoadingDownload)
      //   toast.info("Please wait 1 or 2 minutes. This will take time");
      try {
        const response = await dataService.getData(
          `/SubmitLogbook?userId=${userId || clickedUser.userId}`
        );
        toast.success("Logbook submitted Successfully");

        if (user) {
          const userdata = user;
          dispatch(updateUserData({ ...userdata, completeStatus: true }));
        } else if (userClickedByAdmin) {
          const userdata = userClickedByAdmin;
          dispatch(updateClickedUser({ ...userdata, completeStatus: true }));
        }
        // window.location.reload()
      } catch (error) {
        setErrorResponse(error.response.data);
        setShowValidationDialog(true);
      } finally {
        setIsSubmit(false);
      }
    };
    await fetchDataSubmit();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    // Clean up timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (errorResponse) {
      const uniqueModules = errorResponse
        .map((item) => item.Module)
        .filter((value, index, self) => self.indexOf(value) === index);
      setDownloadFields(uniqueModules);
    }
  }, [errorResponse]);
  useEffect(() => {
    if (downloadFields.length > 0) {
      setActiveField(downloadFields[0]);
    }
  }, [downloadFields]);

  const DashboardIcon = () => (
    <svg
      width="38"
      height="45"
      viewBox="0 0 38 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5V40C0 41.3261 0.44484 42.5979 1.23666 43.5355C2.02848 44.4732 3.10242 45 4.22222 45H33.7778C34.8976 45 35.9715 44.4732 36.7633 43.5355C37.5552 42.5979 38 41.3261 38 40V5C38 3.67392 37.5552 2.40215 36.7633 1.46447C35.9715 0.526784 34.8976 0 33.7778 0H4.22222C3.10242 0 2.02848 0.526784 1.23666 1.46447C0.44484 2.40215 0 3.67392 0 5ZM14.7778 10H31.6667V15H14.7778V10ZM14.7778 20H31.6667V25H14.7778V20ZM14.7778 30H31.6667V35H14.7778V30ZM6.33333 10H10.5556V15H6.33333V10ZM6.33333 20H10.5556V25H6.33333V20ZM6.33333 30H10.5556V35H6.33333V30Z"
        fill="#000000"
      />
    </svg>
  );
  const ProfileIcon = () => (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 10C12.5 7.34784 13.5536 4.8043 15.4289 2.92893C17.3043 1.05357 19.8478 0 22.5 0C25.1522 0 27.6957 1.05357 29.5711 2.92893C31.4464 4.8043 32.5 7.34784 32.5 10C32.5 12.6522 31.4464 15.1957 29.5711 17.0711C27.6957 18.9464 25.1522 20 22.5 20C19.8478 20 17.3043 18.9464 15.4289 17.0711C13.5536 15.1957 12.5 12.6522 12.5 10ZM12.5 25C9.18479 25 6.00537 26.317 3.66117 28.6612C1.31696 31.0054 0 34.1848 0 37.5C0 39.4891 0.790177 41.3968 2.1967 42.8033C3.60322 44.2098 5.51088 45 7.5 45H37.5C39.4891 45 41.3968 44.2098 42.8033 42.8033C44.2098 41.3968 45 39.4891 45 37.5C45 34.1848 43.683 31.0054 41.3388 28.6612C38.9946 26.317 35.8152 25 32.5 25H12.5Z"
        fill="white"
      />
    </svg>
  );
  const CertificateIcon = () => (
    <svg
      width="45"
      height="44"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 0C4.13316 0 2.70242 0.592632 1.64752 1.64752C0.592632 2.70242 0 4.13316 0 5.625V15.9497C2.10984 13.339 5.17037 11.6733 8.50831 11.3191C11.8463 10.9649 15.1882 11.9513 17.7989 14.0611C20.4096 16.1709 22.0753 19.2315 22.4295 22.5694C22.7837 25.9074 21.7973 29.2493 19.6875 31.86V33.75H39.375C40.8668 33.75 42.2976 33.1574 43.3525 32.1025C44.4074 31.0476 45 29.6168 45 28.125V5.625C45 4.13316 44.4074 2.70242 43.3525 1.64752C42.2976 0.592632 40.8668 0 39.375 0H5.625ZM9.84375 11.25C9.47079 11.25 9.1131 11.1018 8.84938 10.8381C8.58566 10.5744 8.4375 10.2167 8.4375 9.84375C8.4375 9.47079 8.58566 9.1131 8.84938 8.84938C9.1131 8.58566 9.47079 8.4375 9.84375 8.4375H35.1562C35.5292 8.4375 35.8869 8.58566 36.1506 8.84938C36.4143 9.1131 36.5625 9.47079 36.5625 9.84375C36.5625 10.2167 36.4143 10.5744 36.1506 10.8381C35.8869 11.1018 35.5292 11.25 35.1562 11.25H9.84375ZM25.3125 21.0938C25.3125 20.7208 25.4607 20.3631 25.7244 20.0994C25.9881 19.8357 26.3458 19.6875 26.7188 19.6875H35.1562C35.5292 19.6875 35.8869 19.8357 36.1506 20.0994C36.4143 20.3631 36.5625 20.7208 36.5625 21.0938C36.5625 21.4667 36.4143 21.8244 36.1506 22.0881C35.8869 22.3518 35.5292 22.5 35.1562 22.5H26.7188C26.3458 22.5 25.9881 22.3518 25.7244 22.0881C25.4607 21.8244 25.3125 21.4667 25.3125 21.0938ZM9.84375 33.75C7.23303 33.75 4.72923 32.7129 2.88317 30.8668C1.03711 29.0208 0 26.517 0 23.9062C0 21.2955 1.03711 18.7917 2.88317 16.9457C4.72923 15.0996 7.23303 14.0625 9.84375 14.0625C12.4545 14.0625 14.9583 15.0996 16.8043 16.9457C18.6504 18.7917 19.6875 21.2955 19.6875 23.9062C19.6875 26.517 18.6504 29.0208 16.8043 30.8668C14.9583 32.7129 12.4545 33.75 9.84375 33.75ZM2.8125 34.4306C4.89388 35.8209 7.34076 36.5628 9.84375 36.5625C12.4453 36.5625 14.8641 35.775 16.875 34.4306V42.1875C16.875 42.4487 16.8023 42.7047 16.665 42.9268C16.5277 43.149 16.3312 43.3285 16.0976 43.4453C15.8641 43.5621 15.6026 43.6115 15.3425 43.5881C15.0824 43.5646 14.8339 43.4692 14.625 43.3125L10.6875 40.3594C10.4441 40.1768 10.148 40.0781 9.84375 40.0781C9.53948 40.0781 9.24342 40.1768 9 40.3594L5.0625 43.3125C4.85357 43.4692 4.60514 43.5646 4.34504 43.5881C4.08494 43.6115 3.82344 43.5621 3.58986 43.4453C3.35627 43.3285 3.15982 43.149 3.02252 42.9268C2.88522 42.7047 2.8125 42.4487 2.8125 42.1875V34.4306Z"
        fill="#F8F8F8"
      />
    </svg>
  );
  const LogbookIcon = (props) => (
    <svg
      width="41"
      height="45"
      viewBox="0 0 41 45"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="eveno dd"
        d="M40.3846 33.3785C40.3818 33.4891 40.371 33.5994 40.3523 33.7085C40.401 33.959 40.3936 34.2172 40.3308 34.4645C40.268 34.7119 40.1512 34.9423 39.9889 35.1392C39.8266 35.3362 39.6227 35.4948 39.3919 35.6037C39.1611 35.7126 38.9091 35.7691 38.6538 35.7692H6.34615C5.96734 35.7692 5.59224 35.8438 5.24226 35.9888C4.89228 36.1338 4.57428 36.3463 4.30642 36.6141C4.03856 36.882 3.82608 37.2 3.68112 37.55C3.53615 37.8999 3.46154 38.275 3.46154 38.6538C3.46154 39.0327 3.53615 39.4078 3.68112 39.7577C3.82608 40.1077 4.03856 40.4257 4.30642 40.6936C4.57428 40.9614 4.89228 41.1739 5.24226 41.3189C5.59224 41.4638 5.96734 41.5385 6.34615 41.5385H38.6538C39.1129 41.5385 39.5531 41.7208 39.8777 42.0454C40.2023 42.37 40.3846 42.8102 40.3846 43.2692C40.3846 43.7283 40.2023 44.1685 39.8777 44.4931C39.5531 44.8177 39.1129 45 38.6538 45H6.34615C4.66305 45 3.04888 44.3314 1.85874 43.1413C0.66861 41.9511 0 40.337 0 38.6538V6.34615C0 4.66305 0.66861 3.04888 1.85874 1.85875C3.04888 0.668611 4.66305 0 6.34615 0H37.2692C38.9908 0 40.3846 1.39385 40.3846 3.11538V33.3785ZM13.2692 9.23077C12.8102 9.23077 12.37 9.41312 12.0454 9.7377C11.7208 10.0623 11.5385 10.5025 11.5385 10.9615C11.5385 11.4206 11.7208 11.8608 12.0454 12.1854C12.37 12.51 12.8102 12.6923 13.2692 12.6923H27.1154C27.5744 12.6923 28.0146 12.51 28.3392 12.1854C28.6638 11.8608 28.8462 11.4206 28.8462 10.9615C28.8462 10.5025 28.6638 10.0623 28.3392 9.7377C28.0146 9.41312 27.5744 9.23077 27.1154 9.23077H13.2692Z"
        fill="#F8F8F8"
      />
    </svg>
  );
  const PerformanceAppraisalIcon = () => (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 32.5364C1 31.3241 1.98279 30.3413 3.19512 30.3413H7.58537C8.7977 30.3413 9.78049 31.3241 9.78049 32.5364V41.3169H1V32.5364Z"
        fill="white"
      />
      <path
        d="M13.0742 24.8536C13.0742 23.6412 14.057 22.6584 15.2693 22.6584H19.6596C20.8719 22.6584 21.8547 23.6412 21.8547 24.8536V41.317H13.0742V24.8536Z"
        fill="white"
      />
      <path
        d="M25.1445 19.3658C25.1445 18.1534 26.1273 17.1707 27.3397 17.1707H31.7299C32.9422 17.1707 33.925 18.1534 33.925 19.3658V41.317H25.1445V19.3658Z"
        fill="white"
      />
      <path
        d="M37.2188 12.7803C37.2188 11.568 38.2015 10.5852 39.4139 10.5852H43.8041C45.0164 10.5852 45.9992 11.568 45.9992 12.7803V41.3169H37.2188V12.7803Z"
        fill="white"
      />
      <path
        d="M0.666643 24.4177C0.425887 24.6018 0.379964 24.9463 0.564072 25.187C0.74818 25.4278 1.0926 25.4737 1.33336 25.2896L0.666643 24.4177ZM10.3293 17.7195L10.2216 17.1814C10.1396 17.1978 10.0624 17.2328 9.99591 17.2836L10.3293 17.7195ZM18.561 16.0732L18.6686 16.6113C18.7822 16.5886 18.8857 16.5305 18.9642 16.4454L18.561 16.0732ZM25.1463 8.93902V8.39024C24.9932 8.39024 24.847 8.45425 24.7431 8.5668L25.1463 8.93902ZM32.8293 8.93902V9.4878C32.9748 9.4878 33.1144 9.42999 33.2173 9.32707L32.8293 8.93902ZM37.7683 4V3.45122C37.6227 3.45122 37.4832 3.50904 37.3802 3.61195L37.7683 4ZM46 4L40.5122 0.831614V7.16839L46 4ZM1.33336 25.2896L10.6626 18.1554L9.99591 17.2836L0.666643 24.4177L1.33336 25.2896ZM10.4369 18.2576L18.6686 16.6113L18.4534 15.535L10.2216 17.1814L10.4369 18.2576ZM18.9642 16.4454L25.5496 9.31125L24.7431 8.5668L18.1577 15.7009L18.9642 16.4454ZM25.1463 9.4878H32.8293V8.39024H25.1463V9.4878ZM33.2173 9.32707L38.1563 4.38805L37.3802 3.61195L32.4412 8.55098L33.2173 9.32707ZM37.7683 4.54878H41.061V3.45122H37.7683V4.54878Z"
        fill="white"
      />
    </svg>
  );
  const AbstractIcon = () => (
    <svg
      width="36"
      height="45"
      viewBox="0 0 36 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 15.75V3.375L32.625 15.75M4.5 0C2.0025 0 0 2.0025 0 4.5V40.5C0 41.6935 0.474106 42.8381 1.31802 43.682C2.16193 44.5259 3.30653 45 4.5 45H31.5C32.6935 45 33.8381 44.5259 34.682 43.682C35.5259 42.8381 36 41.6935 36 40.5V13.5L22.5 0H4.5Z"
        fill="#F8F8F8"
      />
    </svg>
  );

  const MarksheetIcon = () => (
    <svg
      width="38"
      height="45"
      viewBox="0 0 38 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5V40C0 41.3261 0.44484 42.5979 1.23666 43.5355C2.02848 44.4732 3.10242 45 4.22222 45H33.7778C34.8976 45 35.9715 44.4732 36.7633 43.5355C37.5552 42.5979 38 41.3261 38 40V5C38 3.67392 37.5552 2.40215 36.7633 1.46447C35.9715 0.526784 34.8976 0 33.7778 0H4.22222C3.10242 0 2.02848 0.526784 1.23666 1.46447C0.44484 2.40215 0 3.67392 0 5ZM14.7778 10H31.6667V15H14.7778V10ZM14.7778 20H31.6667V25H14.7778V20ZM14.7778 30H31.6667V35H14.7778V30ZM6.33333 10H10.5556V15H6.33333V10ZM6.33333 20H10.5556V25H6.33333V20ZM6.33333 30H10.5556V35H6.33333V30Z"
        fill="#F8F8F8"
      />
    </svg>
  );

  return (
    // <div className='flex'>
    <div className={`block ${openMobileSideBar ? "" : "flex"}`}>
      {/* <div className={` hidden md:block ${isSidebarCollapsed ? 'w-20' : 'w-[300px]'}`}> */}
      <div
        className={` hidden md:block ${
          isSidebarCollapsed ? "w-20  " : "md:w-[250 px] lg:w-[300px]"
        }`}
      >
        <Sidebar />
      </div>
      {/* <div className={` ${isSidebarCollapsed ? 'w-20' : 'w-[300px]'}`}> */}
      <div
        className={` ${
          openMobileSideBar ? "block fixed top-0 z-20" : "hidden"
        } w-lvw block md:hidden`}
      >
        <Sidebar />
      </div>
      <div
        className={`w-full  border-red-700 ${
          isSidebarCollapsed ? "w-[100%-80px ]" : "w-5/6"
        } ${openMobileSideBar ? "w-full top-0" : "w-full"}`}
      >
        <Navbar showStudent={true} />
        <div className="m-4 md:m-8">
          <div className=" flex justify-between">
            <Title title="Explore" />
            {adminRole !== "PartnerCenter" && (
              <div className="flex space-x-5">
                <button
                  disabled={isSubmit}
                  type="button"
                  className={`bg-cyan-800 p-3 flex justify-center px-4 text-base text-white rounded-md  font-poppins ${
                    isLoadingDownload ? "" : ""
                  }`}
                  onClick={handleSubmitLogbook}
                >
                  {/* Downloading logbook automatically re-submits the logbook, we don't want to show loading state while this happens as the loading state is already handled, for other cases, loading state should be shown*/}
                  {
                    <span>
                      {completeStatus ? (
                        <span className="text-[14px]">Re-Submit Logbook</span>
                      ) : (
                        <span className="text-[14px]">Submit Logbook</span>
                      )}{" "}
                    </span>
                  }
                </button>

                {completeStatus && (
                  <button
                    disabled={isLoadingDownload}
                    type="button"
                    className={`bg-cyan-800 p-3 åjustify-center px-4 text-base text-white rounded-md hidden md:block font-poppins ${
                      isLoadingDownload ? "" : ""
                    }`}
                    onClick={handleDownloadLogbook}
                  >
                    <span className="text-[14px]">Download Logbook</span>
                  </button>
                )}
              </div>
            )}
          </div>
          {isLoading ? (
            <div className="mt-8 flex flex-wrap gap-5 lg:gap-3 xl:gap-5 w-full">
              <SkelotonLoaderLogbox />
              <SkelotonLoaderLogbox />
              <SkelotonLoaderLogbox />
              <SkelotonLoaderLogbox />
              <SkelotonLoaderLogbox />
              <SkelotonLoaderLogbox />
            </div>
          ) : (
            <div className="mt-8 flex flex-wrap gap-5 lg:gap-3 xl:gap-5 w-full  ">
              <Link
                to="/profile"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)]"
              >
                <DashboardBox icon={ProfileIcon} name="Profile" />
              </Link>
              <Link
                to="/Certificates"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)]"
              >
                <DashboardBox icon={CertificateIcon} name="Certificates" />
              </Link>
              <Link
                to="/logbook"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)] "
              >
                <DashboardBox icon={LogbookIcon} name="Log Books" />
              </Link>
              <Link
                to="/performanceappraisal"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)]"
              >
                <DashboardBox
                  icon={PerformanceAppraisalIcon}
                  name="Performance Appraisal"
                />
              </Link>
              <Link
                to="/abstract"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)]"
              >
                <DashboardBox icon={AbstractIcon} name="Abstract" />
              </Link>
              <Link
                to="/markingguideline"
                className="w-[calc(50%-10px)] lg:w-[calc(33%-12px)] xl:w-[calc(25%-1rem)]"
              >
                <DashboardBox icon={MarksheetIcon} name="Marksheets" />
              </Link>
            </div>
          )}

          <div className="flex mt-4 w-full">
            {completeStatus && (
              <button
                type="button"
                className="bg-cyan-800 p-3 px-6 text-[14px] font-poppins text-white rounded-md w-full  md:hidden"
                onClick={handleDownloadLogbook}
              >
                {isLoadingDownload ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin "
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  <span>Download Logbook</span>
                )}
              </button>
            )}
          </div>

          {isLoadingDownload && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
              <div className="bg-white  rounded-md shadow-lg h-200px w-300px md:h-400px md:w-800px overflow-y-auto flex flex-col   ">
                <div className="relative flex font-poppins sm:text-xs md:text-base lg: text-lg text-white px-5 py-3 bg-gray-200  w-96 overflow-x-hidden">
                  <div className="flex items-center w-full ">
                    <p className="font-poppins text-[14px] my-0 text-black">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-info-icon lucide-info inline mr-2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16v-4" />
                        <path d="M12 8h.01" />
                      </svg>{" "}
                      Generating Logbook...
                    </p>

                    {/* <span className='cursor-pointer bg-primary-title p-1 ' onClick={handleClose}><ClearIcon /></span> */}
                  </div>
                  <div className="loading-line"></div>
                </div>
                <div className="py-4 px-6 relative overflow-x-hidden">
                  Please wait... This may take few minutes.
                </div>
              </div>
            </div>
          )}

          {isSubmit && !isLoadingDownload && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
              <div className="bg-white  rounded-md shadow-lg h-200px w-300px md:h-400px md:w-800px overflow-y-auto flex flex-col   ">
                <div className="relative flex font-poppins sm:text-xs md:text-base lg: text-lg text-white px-5 py-3 bg-gray-200  w-96 overflow-x-hidden">
                  <div className="flex items-center w-full ">
                    <p className="font-poppins text-[14px] my-0 text-black">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-info-icon lucide-info inline mr-2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 16v-4" />
                        <path d="M12 8h.01" />
                      </svg>{" "}
                      Submitting Logbook...
                    </p>

                    {/* <span className='cursor-pointer bg-primary-title p-1 ' onClick={handleClose}><ClearIcon /></span> */}
                  </div>
                  <div className="loading-line"></div>
                </div>
                <div className="py-4 px-6 relative overflow-x-hidden">
                  Please wait... This may take few minutes.
                </div>
              </div>
            </div>
          )}

          {/* validataion message */}
          {showValidationDialog && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
              <div className="bg-white  rounded-md shadow-lg h-200px w-300px md:h-400px md:w-800px overflow-scroll flex flex-col p-0">
                <div className="flex font-poppins sm:text-xs md:text-base lg: text-lg bg-[#722B2B] text-white p-5">
                  <div className="flex items-center w-full ">
                    <p className="font-poppins text-[14px] my-0">
                      Can't download logbook (Tasks remaining). Complete
                      following tasks to download logbook.
                    </p>
                    {/* <span className='cursor-pointer bg-primary-title p-1 ' onClick={handleClose}><ClearIcon /></span> */}
                  </div>
                </div>
                <div className="flex flex-col  ">
                  {/* top field containing topics that are remaining like logbook, certicicates, abstract, etc */}
                  <div className="flex  bg-[#EAEEF1]  px-5">
                    <div className="flex items-end gap-x-2  md:space-x-2 xl:space-x-4">
                      {downloadFields &&
                        downloadFields.map((item, index) => (
                          <span
                            key={index}
                            className={`font-poppins text-gray-500  cursor-pointer  py-2 pb-4 text-xs md:text-sm lg:text-base ${
                              activeField === item
                                ? "border-b-[3px] border-primary-title  "
                                : "border-b-[3px] border-transparent"
                            }`}
                            onClick={() => setActiveField(item)}
                          >
                            {item}
                          </span>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-between h-full ">
                  {/* this div will containt the error fields */}
                  <div className="p-3 px-5">
                    {errorResponse &&
                      errorResponse
                        .filter((item) => item.Module === activeField) // Filter based on activeField
                        .map((item, index) => (
                          <div key={index} className="flex">
                            <div className="text-[#555555] p-2 border-b w-full text-sm md:font-normal md:text-[15px] font-poppins my-2">
                              <div className="font-extrabold">
                                {item.Heading}
                              </div>
                              <div className="text-[#722B2B] pl-3 font-semibold">
                                {item.Subheading}
                              </div>
                              <div className="pl-6">{item.Message}</div>
                            </div>
                          </div>
                        ))}
                  </div>

                  <div className="mt-3 flex justify-center gap-x-6 pb-3 bg-primary-background p-3">
                    <button
                      onClick={handleClose}
                      className="bg-primary-title text-white font-poppins md:text-[14px] py-2 rounded mr-2 px-8"
                    >
                      OK
                    </button>
                    {/* <button className=" text-primary-title border-2 border-primary-title font-poppins md:text-base lg:text-lg py-2 rounded px-8">
                    NO
                  </button> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
